import axiosWrapper from './axiosWrapper'

const URL_SUCURSAL = `api/suc`
const URL_SUCURSAL_UPDATE = `api/v1/portal/prestador/sucursal/update`

const getSucursal = (axiosParams, uidSucursal) => {
  const url = `${axiosParams.baseURL}/${URL_SUCURSAL}/${uidSucursal}`
  return axiosWrapper.get({ ...axiosParams, url })
}

const guardarSucursal = (axiosParams, data) => {
  const url = `${axiosParams.baseURL}/${URL_SUCURSAL_UPDATE}`
  return axiosWrapper.put({ ...axiosParams, url }, data)
}
const serviceSucursal = {
  getSucursal,
  guardarSucursal
}

export default serviceSucursal
